const allowedRoles = ["underwriting", "admin"];
export default [
  {
    path: "/admin/mortgages",
    component: () =>
      import(
        /* webpackChunkName: "mortgages" */ "@/views/admin/mortgages/ListViewMortgages/ListViewMortgages.vue"
      ),
    meta: {
      pageTitle: "Mortgages",
      requireAuth: true,
      allowedRoles
    }
  },
  {
    path: "/admin/mortgages/activities",
    component: () =>
      import(
        /* webpackChunkName: "mortgages" */ "@/views/admin/mortgages/Activities/MortgageAllActivities.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/mortgages",
          title: "Mortgages"
        }
      ],
      pageTitle: "Mortgages",
      requireAuth: true,
      allowedRoles,
      metaTags: {
        title: "Mortgages"
      }
    }
  },
  {
    path: "/admin/mortgages/:mortgageId/edit",
    component: () =>
      import(
        /* webpackChunkName: "mortgages" */ "@/views/admin/mortgages/EditMortgage.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/mortgages",
          title: "Mortgages"
        }
      ],
      pageTitle: "Edit Mortgage",
      requireAuth: true,
      allowedRoles,
      metaTags: {
        title: "Edit Mortgage",
        description: "Edit Mortgage Details",
        keywords: "Edit Mortgage"
      }
    }
  },
  {
    path: "/admin/mortgages/create",
    component: () =>
      import(
        /* webpackChunkName: "mortgages" */ "@/views/admin/mortgages/CreateMortgage.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/mortgages",
          title: "Mortgages"
        }
      ],
      pageTitle: "Create Mortgage",
      requireAuth: true,
      allowedRoles,
      metaTags: {
        title: "Create Mortgage",
        description: "Create Mortgage",
        keywords: "Create Mortgage"
      }
    }
  }
];
